function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import PaginationHandler from '../common/classes/PaginationHandler';
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
import Layer from '@mozaic-ds/freemarker/js/modules/_layer.js';
import initToggleMenu from '../common/functions/initToggleMenu';
import ContentHandler from '../common/classes/ContentHandler';

/**
 * Component managing the magazine rubrique page.
 * Handles pagination, category filtering via a modal layer,
 * active filter tag management, as well as accordion and layer initialisation.
 *
 * @class MagazineRubrique
 * @extends lm.Composant
 */
var MagazineRubrique = /*#__PURE__*/function (_lm$Composant) {
  /**
   * Initialises the MagazineRubrique component.
   * Sets up pagination, the filter layer, active filter tags,
   * accordions and toggle menus.
   *
   * @constructor
   * @param {String} id - The DOM identifier of the root component element.
   */
  function MagazineRubrique(id) {
    var _this;
    _classCallCheck(this, MagazineRubrique);
    _this = _callSuper(this, MagazineRubrique, [id]);
    var filterSeparator = ";";

    // Init pagination display
    var paginationParam = new URL(document.location).searchParams.get("p");
    var filterParam = new URL(document.location).searchParams.get("filter");
    scrollMagazineRubriqueIntoView();
    initBrowserUrl();
    initTags();

    // Init pagination – same pattern as listHowToChoose
    new PaginationHandler();

    // Filter Layer
    var filterLayer = document.querySelector(".js-filters-layer");
    var openFilterLayerButton = document.getElementById('js-open-filter-layer');
    if (!filterLayer) return _possibleConstructorReturn(_this);
    var closeFilterLayerButton = filterLayer.querySelector(".js-close-layer");
    if (openFilterLayerButton) {
      openFilterLayerButton.addEventListener('click', openLayer);
      openFilterLayerButton.addEventListener('keydown', function (event) {
        if (event.code === "Enter" || event.code === "Space") {
          event.preventDefault();
          openLayer();
        }
      });
    }
    if (closeFilterLayerButton) {
      closeFilterLayerButton.addEventListener('click', function (event) {
        event.preventDefault();
        closeLayer();
      });
    }
    var submitFilterButton = filterLayer.querySelector(".js-submit-filter");
    submitFilterButton.addEventListener('click', onSubmitFilterForm);
    var eraseAllFilterButton = filterLayer.querySelector(".js-erase-all-filter");
    eraseAllFilterButton.addEventListener('click', onClickEraseAllFilter);
    initToggleMenu();
    new ContentHandler('Rubriques');

    /**
     * Scrolls the page to bring the content container into view
     * when a pagination parameter is present in the URL.
     *
     * @returns {void}
     */
    function scrollMagazineRubriqueIntoView() {
      if (paginationParam) {
        document.querySelector('.js-content-loader-container').scrollIntoView();
      }
    }

    /**
     * Updates the browser URL (without a page reload) to reflect
     * the current page and active filters on initial load.
     * Uses {@link History.replaceState} to avoid polluting the browser history.
     *
     * @returns {void}
     */
    function initBrowserUrl() {
      var url = new URL(document.location);
      if (paginationParam) {
        if (filterParam) {
          window.history.replaceState("", "", "?p=" + currentPage + "&filter=" + url.search.slice(url.search.indexOf("filter=") + "filter=".length));
        } else {
          window.history.replaceState("", "", "?p=" + currentPage);
        }
      }
    }

    /**
     * Initialises the state of the filter form checkboxes
     * based on the filters present in the "filter" URL parameter.
     * Unchecks all boxes, then re-checks those matching the active filters.
     *
     * @returns {void}
     */
    function initFilterForm() {
      filterLayer.querySelectorAll("input[type='checkbox']").forEach(function (input) {
        input.checked = false;
      });
      var urlParams = new URLSearchParams(document.location.search);
      if (urlParams.size > 0 && urlParams.has("filter")) {
        var filters = decodeFilterParam(urlParams.get("filter").split(filterSeparator));
        filters.forEach(function (filter) {
          return checkFilter(filter.split(":"));
        });
      }
    }

    /**
     * Creates and displays the tags corresponding to the active filters
     * read from the "filter" URL parameter on page load.
     *
     * @returns {void}
     */
    function initTags() {
      if (filterParam) {
        var categories = decodeFilterParam(filterParam.split(filterSeparator));
        var filters = [];
        categories.forEach(function (categorie) {
          filters.push(categorie.split(":")[1]);
        });
        createTags(filters);
      }
    }

    /**
     * Decodes the list of filters encoded in the URL by reconstructing
     * values that contain the separator (`;`) as part of their name.
     * Invalid entries (without `:`) are merged with the preceding entry.
     *
     * @param {string[]} filters - Array of strings obtained by splitting the "filter" parameter.
     * @returns {string[]} Array of valid filters in the "id:name" format.
     */
    function decodeFilterParam(filters) {
      filters.forEach(function (filter, index) {
        if (!filter.includes(":")) {
          filters[index - 1] += filterSeparator + filter;
          filters[index] = null;
        }
      });
      return filters.filter(function (filter) {
        return filter != null;
      });
    }

    /**
     * Checks the checkbox in the filter form that matches
     * the provided filter identifier and name.
     *
     * @param {string[]} filter - Two-element array: [id, name] of the filter to check.
     * @returns {void}
     */
    function checkFilter(filter) {
      var id = filter[0];
      var name = filter[1];
      var inputs = filterLayer.querySelectorAll("input");
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].id.startsWith(id) && inputs[i].name === name) {
          inputs[i].checked = true;
        }
      }
    }

    /**
     * Opens the filter layer (side panel).
     * Initialises the filter form, makes the overlay visible,
     * opens the dialog and the accordion, moves focus to the close button,
     * sets up Tab key focus trapping, and registers the overlay click handler to close the layer.
     *
     * @returns {void}
     */
    function openLayer() {
      initFilterForm();
      var layerOverlay = document.getElementById("js-filter-layer-overlay");
      layerOverlay.classList.add("is-visible");
      filterLayer.querySelector(".mc-layer__dialog").classList.add('is-open');
      filterLayer.querySelector(".mc-accordion").classList.add("is-open");
      setTimeout(function () {
        filterLayer.querySelector("button.mc-layer__close").focus();
      }, 400);
      eraseAllFilterButton.addEventListener('keydown', function (event) {
        if (event.code === "Tab") {
          event.preventDefault();
          filterLayer.querySelector("button.mc-layer__close").focus();
        }
      });

      // We need to add event on overlay to close layer
      layerOverlay.addEventListener('click', closeLayer);
    }

    /**
     * Closes the filter layer (side panel).
     * Hides the overlay, closes the dialog and all accordions inside the layer,
     * then returns focus to the filter open button.
     *
     * @returns {void}
     */
    function closeLayer() {
      // Same as the openFilterLayerButton up
      var layerOverlay = document.getElementById("js-filter-layer-overlay");
      layerOverlay.classList.remove("is-visible");
      filterLayer.querySelector(".mc-layer__dialog").classList.remove('is-open');
      var accordions = filterLayer.querySelectorAll(".mc-accordion");
      accordions.forEach(function (accordion) {
        accordion.classList.remove("is-open");
      });
      openFilterLayerButton.focus();
    }

    /**
     * Handles the submission of the filter form.
     * Closes the layer, builds the "filter" parameter value from the checked boxes,
     * then navigates to the filtered page via {@link navigateWithFilter}.
     *
     * @returns {void}
     */
    function onSubmitFilterForm() {
      closeLayer();
      var filterUrlValue = "";
      var inputs = filterLayer.querySelectorAll(".mc-checkbox__input:checked");
      inputs.forEach(function (element) {
        return filterUrlValue += element.dataset.filterCode + ":" + element.name + filterSeparator;
      });
      filterUrlValue = filterUrlValue.substring(0, filterUrlValue.length - 1); //remove last ,
      filterUrlValue = encodeURIComponent(filterUrlValue);
      navigateWithFilter(filterUrlValue);
    }

    /**
     * Unchecks all currently selected checkboxes in the filter layer.
     *
     * @returns {void}
     */
    function removeAllCheckedFilters() {
      var inputs = filterLayer.querySelectorAll(".mc-checkbox__input:checked");
      inputs.forEach(function (element) {
        return element.checked = false;
      });
    }

    /**
     * Creates and inserts the active filter tags as well as
     * the "Reset all filters" link into the dedicated container in the DOM.
     *
     * @param {string[]} filters - Array of active filter names to display as tags.
     * @returns {void}
     */
    function createTags(filters) {
      var filterTagContainer = document.getElementById("rubrique-filter-tags");
      var fragment = document.createDocumentFragment();
      if (filters.length > 0) {
        filters.forEach(function (filter) {
          var tag = buildTag(filter);
          fragment.append(tag);
        });
        filterTagContainer.append(fragment);
        var resetAllFiltersLink = buildResetAllFiltersLink();
        filterTagContainer.append(resetAllFiltersLink);
      }
    }

    /**
     * Builds and returns a removable tag element representing an active filter.
     * The tag contains the filter label and a remove button.
     * A click listener is attached to remove the corresponding filter from the URL.
     *
     * @param {string} filter - The filter name to display inside the tag.
     * @returns {HTMLSpanElement} The span element representing the removable tag.
     */
    function buildTag(filter) {
      var tag = document.createElement("span");
      var spanLabel = tag.cloneNode();
      spanLabel.className = "mc-tag-removable__label";
      spanLabel.textContent = filter;
      var spanText = spanLabel.cloneNode();
      spanText.className = "mc-tag-removable__remove-text";
      var buttonRemove = document.createElement("button");
      buttonRemove.className = "mc-tag-removable__remove";
      buttonRemove.ariaLabel = deleteLabel;
      buttonRemove.appendChild(spanText);
      tag.className = "mc-tag-removable js-rubrique-filters-remove-btn";
      tag.dataset.paramName = filter;
      tag.append(spanLabel, buttonRemove);
      tag.addEventListener("click", onClickTagRemovable);
      return tag;
    }

    /**
     * Builds and returns the "Reset all filters" link element.
     * Clicking this link removes all active filters by navigating
     * to the URL without any filter parameter.
     *
     * @returns {HTMLAnchorElement} The anchor element for resetting all filters.
     */
    function buildResetAllFiltersLink() {
      var resetAllFiltersLink = document.createElement("a");
      resetAllFiltersLink.id = "js-reset-filters-btn";
      resetAllFiltersLink.className = "js-reset-filters-btn";
      resetAllFiltersLink.textContent = resetAllFiltersLinkLabel;
      resetAllFiltersLink.addEventListener("click", onClickResetFiltersBtn);
      return resetAllFiltersLink;
    }

    /**
     * Handles a click on a removable filter tag.
     * Retrieves the filter name associated with the clicked tag, removes it from
     * the list of active filters in the URL, then navigates to the updated URL.
     *
     * @param {MouseEvent} event - The click event triggered on the tag.
     * @returns {void}
     */
    function onClickTagRemovable(event) {
      var filterNameToDelete = event.target.parentElement.dataset.paramName;
      var urlParams = new URLSearchParams(document.location.search);
      if (!urlParams.has("filter")) return;
      var currentFilters = decodeFilterParam(urlParams.get("filter").split(filterSeparator));
      var remainingFilters = currentFilters.filter(function (f) {
        return f.split(":")[1] !== filterNameToDelete;
      });
      var filterUrlValue = remainingFilters.length > 0 ? encodeURIComponent(remainingFilters.join(filterSeparator)) : "";
      navigateWithFilter(filterUrlValue);
    }

    /**
     * Handles a click on the reset-all-filters link.
     * Prevents the default link navigation and navigates to the URL without any filter.
     *
     * @param {MouseEvent} event - The click event triggered on the reset link.
     * @returns {void}
     */
    function onClickResetFiltersBtn(event) {
      event.preventDefault();
      navigateWithFilter("");
    }

    /**
     * Handles a click on the "Erase all filters" button inside the layer.
     * Unchecks all selected checkboxes in the filter form.
     *
     * @returns {void}
     */
    function onClickEraseAllFilter() {
      removeAllCheckedFilters();
    }

    /**
     * Navigates to the current page with the given filter value in the URL.
     * Using a real page navigation (instead of AJAX) ensures the server renders
     * the correct filtered content and the URL state is always canonical —
     * the same approach as the select-based filter in _filters.ftl.
     *
     * @param {string} filterValue - Encoded filter value to include in the URL (may be empty).
     * @returns {void}
     */
    function navigateWithFilter(filterValue) {
      if (filterValue) {
        window.location.assign(window.location.pathname + "?filter=" + filterValue);
      } else {
        window.location.assign(window.location.pathname);
      }
    }

    // Accordion steps
    _toConsumableArray(_this.target.querySelectorAll('.js-accordion')).forEach(function (el) {
      new Accordion(el);
    });

    // Layer steps
    _toConsumableArray(_this.target.querySelectorAll('.js-filters-layer')).forEach(function (el) {
      new Layer(el);
    });
    return _this;
  }
  _inherits(MagazineRubrique, _lm$Composant);
  return _createClass(MagazineRubrique);
}(lm.Composant);
lm.DOMReady(function () {
  new MagazineRubrique('magazinerubrique');
});